export default {
    textXS:'10px',
    textS:'14px',
    textM:'16px',
    textL:'20px',  
    textWeight:'bold',
    headline1:'36px',
    headline2:'28px',
    headline3:'24px',
    headline4:'20px',
}